<template>
    <div>
    <validation>
        <div class="textalign_right tab_position">
            <div v-bind:class="['logintab',{active: currentarea== 'mainland'}]" @click="loginarea('mainland')">中国大陆用户</div>
            <div v-bind:class="['logintab',{active: currentarea== 'other'}]" @click="loginarea('other')">港澳台/海外用户</div>
        </div>
        <div class="flex_1 registertitle" v-if="currentarea== 'mainland'">
            <div class="textalign_center">
                <div class="tabtype"><span class="tabText">注册</span></div>
            </div>
            <div>
                <div class="field margin-top">
                    <div v-bind:class="['fieldtip',{animation: registerFocus.account}]">输入手机号</div>
                    <div class="fielderror" v-if="registererror.account &&  (!registervalue.account)">手机号不能为空</div>
                    <input type="" name="" @keyup.enter="login" v-bind:class="['fieldinput',{error: registererror.account &&  (!registervalue.account)}]" v-model="registervalue.account" @focus="registerfocusfun('account')" @blur="registerblurfun('account')">
                </div>
                <div class="field">
                    <div class="left_field  inline-block">
                        <div v-bind:class="['fieldtip',{animation: registerFocus.verifycode}]">输入验证码</div>
                        <div class="fielderror" v-if="registererror.verifycode && (!registervalue.verifycode)">验证码不能为空</div>
                        <input type="" @keyup.enter="login" name="" v-bind:class="['fieldinput',{error: registererror.verifycode && (!registervalue.verifycode)}]" v-model="registervalue.verifycode" @focus="registerfocusfun('verifycode')" @blur="registerblurfun('verifycode')">
                    </div>
                    <div class="right_field  inline-block" @click="getcaptcha()">
                        {{seconds ? seconds +'S': '获取验证码' }}
                    </div>
                </div>
                <div class="field">
                    <div v-bind:class="['fieldtip',{animation: registerFocus.password}]">设置密码</div>
                    <div class="fielderror" v-if="registererror.password && (!registervalue.password)">密码不能为空</div>
                    <input type="password" @keyup.enter="login" name="" v-bind:class="['fieldinput',{error: registererror.password && (!registervalue.password)}]" v-model="registervalue.password" @focus="registerfocusfun('password')" @blur="registerblurfun('password')">
                </div>
                <div class="field">
                    <div v-bind:class="['fieldtip',{animation: registerFocus.password2}]">确认密码</div>
                    <div class="fielderror" v-if="registererror.password2 && (!registervalue.password2)">密码不能为空</div>
                    <input type="password" @keyup.enter="login" name="" v-bind:class="['fieldinput',{error: registererror.password2 && (!registervalue.password2)}]" v-model="registervalue.password2" @focus="registerfocusfun('password2')" @blur="registerblurfun('password2')">
                </div>
            </div>
            <div class="loginbtn" @click="register()">注册</div>
            <div class="display_flex  justify-content_flex-justify width_320">
                <div class="cursor_p" @click="gorouter('/login?region=0')">已有账号？马上登录</div>
                <div class="cursor_p" @click="gorouter('/reset?region=0')">忘记密码</div>
            </div>
        </div>
        <div style="width:45%;height:100%;padding-top:48px;" class="flex_1" v-if="currentarea== 'other'">
            <div class="textalign_center">
                <div class="tabtype"><span class="tabText">郵箱注册</span></div>
            </div>
            <div v-if="register_first">
                <div class="field margin-top" >
                    <div v-bind:class="['fieldtip',{animation: registerFocus.email}]">输入注册郵箱地址</div>
                    <div class="fielderror" v-if="registererror.email &&  (!registervalue.email)">郵箱地址不能为空</div>
                    <input type="" name="" @keyup.enter="login_getemail" v-bind:class="['fieldinput',{error: registererror.email &&  (!registervalue.email)}]" v-model="registervalue.email" @focus="registerfocusfun('email')" @blur="registerblurfun('email')">
                </div>
                <div class="loginbtn" @click="login_getemail()">获取验证邮件</div>
                <div class="display_flex  justify-content_flex-justify width_320">
                    <div class="cursor_p" @click="gorouter('/login?region=1')">已有账号？马上登录</div>
                    <div class="cursor_p" @click="gorouter('/reset?region=1')">忘记密码</div>
                </div>
            </div>
            <div v-if="register_next">
                <div class="maildesc">
                    <div>驗證郵件已發送至{{registervalue.email}}</div>
                    <div class="padding_20">* 如果您在“收件箱”中沒收到驗證郵件， 請查看一下“垃圾郵件”文件夾；如果5分鐘後還沒有收到，可以再次請求發送。</div>
                </div>
                <div class="loginbtn" @click="login_getemail()">{{startcount? seconds+'S 重新获取':'重新发送'}}</div>
                <div class="display_flex  justify-content_flex-justify width_320">
                    <div class="cursor_p" @click="gorouter('/')">首页</div>
                    <div class="cursor_p" ></div>
                </div>
            </div>
        </div>
    </validation>
    <modal ref="modaltoast" @modalthings="countfun($event)"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.logincontain {
    height: 100%;
    // background: linear-gradient(337deg, #28D877 0%, #0DC6B8 100%);
    //    opacity: 0.6029;
}

.login_header_right {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 32px;
}

.login_content {

    // background: linear-gradient(337deg, #28D877 0%, #0DC6B8 100%);
    // opacity: 0.6029;
}

.login_content_box {
    max-width: 940px;
    margin: 0px auto 0;
    height: 510px;
    box-sizing: border-box;
    background: #fff;
    padding-top: 30px;
    box-sizing: border-box;
}

.login_header {
    width: 940px;
    height: 100px;
    margin: 0 auto;

}

.padding_top_64 {
    padding-top: 64px;
    box-sizing: border-box;
}

.logintab {
    width: 230px;
    height: 40px;
    line-height: 40px;
    background: #CEF4E6;
    border-radius: 8px 8px 0px 0px;
    display: inline-block;
    color: #51515C;
    text-align: center;
    cursor: pointer;

    &.active {
        background: #fff;
        color: #60DEB4;
    }
}

.tab_position {
    position: absolute;
    top: -10px;
    right: 0;
}

.banneritem {
    width: 100%;
    height: 200px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;


}

.login_swiper_title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 24px;
    padding-top: 30px;
    box-sizing: border-box;
}

.login_swiper_desc {
    padding-top: 8px;
    box-sizing: border-box;
    width: 336px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 24px;
    text-align: center;
    margin: 0 auto;
}

.tabtype {
    display: inline-block;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    position: relative;

    .tabText {
        cursor: pointer;

        &.active:after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: -20px;
            transform: translate(-50%, -50%);
            width: 40px;
            height: 8px;
            background: url('http://p1.fishqc.net/FjqWRRna4idwPR9ZmZkYK5D19Xxn') no-repeat;
        }
    }

    &:nth-of-type(2) {
        margin-left: 32px;
    }
}

.field {
    width: 320px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 58px;
    position: relative;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    &.margin-top {
        margin-top: 20px;
    }

    .fieldtip {
        position: absolute;
        left: 0;
        color: #333;
        bottom: 10px;
        font-size: 14px;
        line-height: 20px;
        transition: all .4s linear;

        &.animation {
            bottom: 32px;
            font-size: 12px;
            line-height: 16px;

        }
    }

    .fielderror {
        position: absolute;
        right: 0;
        color: #ff3366;
        bottom: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    .fieldcodeerror {
        position: absolute;
        right: 31%;
        color: #ff3366;
        bottom: 10px;
        font-size: 14px;
        line-height: 20px;
    }

    .fieldinput {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border: none;
        font-size: 14px;
        height: 24px;
        line-height: 32px;
        color: #333;
        border-bottom: 2px solid #F8FBFD;

        &.codebox {
            width: 70%;
        }

        &.error {
            border-bottom: 2px solid #ff3366;
        }
    }

    .codedetail {
        width: 30%;
        display: inline-block;
        position: absolute;
        right: 0;
        bottom: 0;
        height: 100%;
        cursor: pointer;
    }

    .left_field {
        position: absolute;
        width: 66%;
        height: 100%;
        vertical-align: middle;
        left: 0;
    }

    .right_field {
        position: absolute;
        bottom: 10px;
        right: 0;
        width: 30%;
        vertical-align: middle;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            width: 1px;
            height: 20px;
            left: 0px;
            background-color: #999;
        }
    }
}

.loginbtn {
    width: 320px;
    height: 48px;
    background: #60DEB4;
    margin: 24px auto 16px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}

.width_320 {
    width: 320px;
    margin: 0 auto;
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #2F3736;
}

.otherlogin {
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #848A95;
    line-height: 17px;
    margin: 32px 0 18px;
    box-sizing: border-box;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        width: 80px;
        height: 1px;
        background-color: #DDDDDD;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
    }

    &:after {
        content: '';
        position: absolute;
        width: 80px;
        height: 1px;
        background-color: #DDDDDD;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
    }
}

.facebookbtn {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    background: #1877F2;
}

.margin_right_10 {
    margin-right: 10px;
}

.registertitle {
    width: 45%;
    height: 100%;
    padding-top: 48px;
    box-sizing: border-box;
}

.maildesc{
    font-size: 16px;
    line-height:24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding:40px 40px 10px;
    box-sizing: border-box;
    .padding_20{
        padding-top: 20px;
        box-sizing: border-box;
    }
}
</style>
<style type="text/css" lang="scss">
.login_content {

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
        bottom: 98px;
        left: 0;
        width: 100%;
    }
}
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'
import validation from '@/components/validation.vue'
import { registerApi,register_sendCodeApi,sendMailCodeapi } from '@/api/api.js'
import Modal from '@/components/Modal.vue'
var countTimer
var email_reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var tel_reg = /^1\d{10}$/;
export default {
    name: 'login',
    props: {
        list: Array

    },
    components: {
        validation: validation,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            swiperOption: {
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                //自动轮播
                // autoplay: {
                //     delay: 2000,
                //       //当用户滑动图片后继续自动轮播
                //     disableOnInteraction: false,
                // },
                //开启循环模式
                loop: false,

            },
            // 聚焦参数
            accountfocus: false,
            passwordfocus: false,
            codefocus: false,
            // value
            accountvalue: '',
            passwordvalue: '',
            password2value:'',
            codevalue: '',
            captchavalue:'',
            // error
            accounterror: false,
            passworderror: false,
            captchaerror:false,
            codeerror: false,
            captchaimg: '/Activation/captcha?t=',
            currentarea: 'mainland',
            // register 
            registerFocus:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
                email:false,
            },
            registerBlur:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
                email:false,
            },
            registererror:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
                email:false,
            },
            registertip:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
                email:false,
            },
            registervalue:{
                account:'',
                password:'',
                password2:'',
                captcha:'',     //图形验证码
                verifycode:'',   //短信验证码
                email:'',
            },
           
            register_first:true,
            register_next:false,
            seconds:0,
            startcount:true

        }
    },
    methods: {
        // 聚焦
        registerfocusfun(type){
            this.registerFocus[type] = true
            switch(type){
                case 'account':
                if(!this.registervalue.account){
                    this.registererror[type] = false
                    return
                }
                break
                case 'verifycode':
                if(!this.registervalue.verifycode){
                    this.registererror[type] = false
                    return
                }
                break
                case 'password':
                if(!this.registervalue.password){
                    this.registererror[type] = false
                    return
                }
                break
                case 'password2':
                if(!this.registervalue.password2){
                    this.registererror[type] = false
                    return
                }
                break
                case 'email':
                if(!this.registervalue.email){
                    this.registererror[type] = false
                    return
                }
                break
            }
        },
        // 失焦
        registerblurfun(type){
            switch(type){
                case 'account':
                if(!this.registervalue.account){
                    this.registerFocus[type] = false
                    
                }
                break
                case 'verifycode':
                if(!this.registervalue.verifycode){
                    this.registerFocus[type] = false
                }
                break
                case 'password':
                if(!this.registervalue.password){
                    this.registerFocus[type] = false
                }
                break
                case 'password2':
                if(!this.registervalue.password2){
                    this.registerFocus[type] = false
                }
                break
                case 'email':
                if(!this.registervalue.email){
                    this.registerFocus[type] = false
                    return
                }
                break

            }
            this.registererror[type] = true
            
        },
        // 更新图形验证码
        // changecaptcha() {
        //     var rand = Math.random();
        //     this.captchaimg = this.captchaimg + rand
        // },
        register() {

            if (!this.registervalue.account) {
                this.registererror['account'] = true
                return
            }

            if(!tel_reg.test(this.registervalue.account)){
                this.toast('手机号格式不对！')
            }

            if (!this.registervalue.captcha) {
                this.toast('点击获取验车码！')
                this.registererror['captcha'] = true
                return
            }

            if (!this.registervalue.verifycode) {
                this.toast('请输入短信验证码！')
                this.registererror['verifycode'] = true
                return
            }

            if (!this.registervalue.password) {
                this.registererror['password'] = true
                return
            }

            if (!this.registervalue.password2) {
                this.registererror['password2'] = true
                return
            }

            if(this.registervalue.password !== this.registervalue.password2){
                this.toast('确认密码不一致！')
                return
            }

            registerApi({
                mobile: this.registervalue.account,
                password: this.registervalue.password,
                password2:this.registervalue.password2,
                verifycode:this.registervalue.verifycode,
                captcha: this.registervalue.captcha,
                returnURL: this.$route.query.returnURL,
                source:''

            }).then(res => {
                if (res.code == 200) {
                    this.gorouter('/')
                    // if (this.$route.query.returnURL) {
                    //     this.gorouter(this.$route.query.returnURL)
                    // } else {
                    //     this.gorouter('/')
                    // }
                } else {
                    // this.changecaptcha()
                    this.toast(res.message)

                }
            })

        },
        //选择登陆方式（大陆还是港澳/海外）
        loginarea(area) {
            this.currentarea = area
        },
        // 弹窗显示并获取图形验车码
        getcaptcha(){
            if (!this.registervalue.account) {
                this.toast('请输入手机号')
                return
            }

            this.$refs.modaltoast.show({
                type:'verifycodemodal',
            });
        },
        // 弹窗回调传值图形验证码，倒计时开始，触发发送手机短信验证码
        countfun(data){
            var that = this;
            if(data.captcha){
                that.registervalue.captcha = data.captcha
            }
            
            that.seconds = 60
            that.sendverifycode()
            countTimer = setInterval(function() {
                that.seconds--;
                if (that.seconds <= 0) {
                    if(data.source == 'login_getemail'){
                        that.startcount = false
                    }
                    countTimer = clearInterval(countTimer);
                }
            }, 1000);

        },
        // 发送手机短信
        sendverifycode(){
            register_sendCodeApi({
                mobile: this.registervalue.account,
                captcha: this.registervalue.captcha
            }).then(res => {
                if (res.code == 200) {
                   
                } else {
                    this.toast(res.message)

                }
            })
        },
        login_getemail(){

            console.log(this.registervalue.email)
            if (!this.registervalue.email) {
                this.registererror['email'] = true
                return
            }

            if(!email_reg.test(this.registervalue.email)){
                this.toast('邮箱格式不对！')
            }
            console.log('调用接口')

            sendMailCodeapi({
                mail: this.registervalue.email,
                returnURL: this.$route.query.returnURL
            }).then(res => {
                if (res.code == 200) {
                   // 
                   this.register_first = false
                   this.register_next = true
                   this.countfun({
                        source:'login_getemail'
                   })
                  
                } else {
                    this.toast(res.message)

                }
            })
        },

    },
    watch:{
    },
    computed: {},
    mounted() {
        if(this.$route.query.region == 0){
            this.currentarea = 'mainland'
        }else{
            this.currentarea = 'other'
        }
    }
}
</script>